__turbopack_context__.v({
  "light-panel": "navigation-panel-module-scss-module__hvlgAG__light-panel",
});
